import Vue from "vue";
import Router from "vue-router";
import index from "@/views/Home/index.vue";
import equiry from "@/components/enquiry";
import contact from "@/components/contact";
import caterers from "@/components/caterers";
import call from "@/components/call";
import footer from "@/components/footer";
import partyFood from "@/components/party_food";
import christmasParty from "@/components/christmas_party";
import birthdayParty from "@/components/birthday_party";
import junkCatering from "@/components/junk-catering";
import weddingCatering from "@/components/wedding-catering";
import snackCatering from "@/components/snack-catering";
import chineseCatering from "@/components/chinese-catering";
import westernCatering from "@/components/western-catering";
import thaiCatering from "@/components/thai-catering";
import vegetarianCatering from "@/components/vegetarian-catering";
import bento from "@/components/bento";
import corporateCatering from "@/components/corporate-catering";
import centralAndWestern from "@/components/central-and-western";
import eastern from "@/components/eastern";
import wanChai from "@/components/wan-chai";
import kwunTong from "@/components/kwun-tong";
import shamShuiPo from "@/components/sham-shui-po";
import yauTsimMong from "@/components/yau-tsim-mong";
import kwaiTsing from "@/components/kwai-tsing";
import saiKung from "@/components/sai-kung";
import shaTin from "@/components/sha-tin";
import tsuenWan from "@/components/tsuen-wan";
import tuenMun from "@/components/tuen-mun";
import yuenLong from "@/components/yuen-long";
import terms from "../components/terms.vue";
import privacy from "../components/privacy.vue";
import client from "@/views/PastCooperativeCustomers/index.vue";
import halloween from "../components/halloween.vue";
import notfind from '../components/404.vue'
import proDetails from '../components/products/proDetails'

const originalPush = Router.prototype.push;

Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch(err => err);
};
Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "index",
      component: index,
      meta: {
        title: "香港到會服務推介 | 美食食物到會公司 - 到會家 Cateraway",
        description:
          "搞派對聚會，「到會家」嘅1人1款皇牌平價自選到會，無論香港、九龍或新界都可送到。我們到會服務公司的食物製作以優質見稱，有70多款美食推介任君選擇！",
        keywords:
          "香港到會,到會,到會服務,到會推介,到會服務推介,到會食物推介,美食到會,到會公司",
      }
    },
    {
      path: "/en",
      name: "indexen",
      component: index,
      meta: {
        title: "Catering Service Provider Company Hong Kong - Cateraway",
        description:
          "At Cateraway, we are an energetic and dedicated HK catering service provider serving individual and company clients. Our menus are unique, inventive and out of the ordinary.",
        keywords:
          "catering,catering hk,catering service,catering service provider,catering service company,catering service hk,catering service hong kong"
      }
    },
    {
      path: "/menu",
      name: "caterers",
      component:() => import('@/views/CaterawayReserve/index.vue'),
      meta: {
        title: "到會餐單餐牌 | 平價到會 - 到會家 Cateraway",
        description:
          "我們有不同類型的平價到會餐單，包括私人、商務派對、小朋友生日會、船P到會及午餐會等等類型的到會餐牌，皇牌餐單平均只需約$82/款就可以品嚐美味的到會，物美價廉真係超值啊！",
        keywords: "到會餐單,到會餐牌,平價到會,到會平"
      }
    },
    {
      path: "/en/menu",
      name: "caterersen",
      component:() => import('@/views/CaterawayReserve/index.vue'),
      meta: {
        title: "Catering Menu - Cateraway",
        description:
          "We offer a variety of menus for you to cater for different occasions including private parties, business meetings, kids’ birthday parties, junk boat parties, or cocktail parties etc. Pick your dish at an affordable price. Deliver to Hong Kong Island, Kowloon and New Territories. Order Now.",
        keywords:
          "To the menu, to the menu, the price to the meeting, to the meeting"
      }
    },
    {
      path: "/client",
      name: "client",
      component: client,
      meta: {
        title: "過住知名客戶",
        description: ""
      }
    },
    {
      path: "/en/client",
      name: "clienten",
      component: client,
      meta: {
        title: "Our Clients - Cateraway",
        description: "We have been serving for more than 700 thousands customers. Key clients include FWD, L'hotel, PWC and more."
      }
    },
    {
      path: "/halloween",
      name: "halloween",
      component: halloween,
      meta: {
        title: "萬聖節到會 | 萬聖節派對更好食好玩 - 到會家 Cateraway",
        description: "Helloween又嚟啦！需要萬聖節派對到會服務？到會家提供多款優惠價$82/盤的派對到會皇牌美食，小食、炸物、甜品，一應俱存。多年到會經驗，保證食材新鮮，熱辣辣送到府上。絕對是萬聖節到會，派對活動的必然之選！立即預訂！",
        keywords: "message.meta.halloween.keywords"
      }
    },
    {
      path: "/en/halloween",
      name: "halloweenen",
      component: halloween,
      meta: {
        title: "Halloween Party Catering - Cateraway",
        description: "Cateraway provides Halloween catering services for your Halloween Parties. Cateraway’s Halloween menus serves gourmets from Thai food, Chinese, Western, Vegetarian and a lot more. Deliver straight at your doorstep. Order Now",
        keywords: "message.meta.halloween.keywords"
      }
    },
    {
      path: "/terms",
      name: "terms",
      component: terms,
      meta: {
        title: "到會家條款與細則 - 到會家 Cateraway",
        description: "到會家條款與細則。香港第一到會服務推介。 適合Party 派對聚會、公司茶聚到會、生日會到會、船P 船河到會、婚禮到會婚宴、聖誕到會。絕對是到會的首選！"
      }
    },
    {
      path: "/en/terms",
      name: "termsen",
      component: terms,
      meta: {
        title: "Terms and Conditions - Cateraway",
        description: "Terms and conditions of Cateraway. Hong Kong’s #1 Catering Service Provider. We provide personalized catering services, corporate & events catering services."
      }
    },
    {
      path: "/privacy",
      name: "privacy",
      component: privacy,
      meta: {
        title: "到會家隱私條款 - 到會家 Cateraway",
        description: "到會家隱私條款。香港第一到會服務推介。 適合Party 派對聚會、公司茶聚到會、生日會到會、船P 船河到會、婚禮到會婚宴、聖誕到會。絕對是到會的首選！"
      }
    },
    {
      path: "/en/privacy",
      name: "enprivacy",
      component: privacy,
      meta: {
        title: "Privacy Policy - Cateraway",
        description: "Privacy policy of Cateraway. Hong Kong’s #1 Catering Service Provider. We provide personalized catering services, corporate & events catering services."
      }
    },
    {
      path: "/equiry",
      name: "enquiry",
      component: equiry,
      meta: {
        title: "到會報價｜報價服務推介- 到會家 Cateraway",
        description:
          "專營超過30款不同類型的商務活動餐飲報價，食物及服務包括廚師即制、Canapés、Finger Food、公司開幕、雞尾酒會、便當、大型活動、小食拼盤、週年晚會等，提供1對1的專人到會報價服務。",
        keywords:
          "活動餐飲報價,報價服務,廚師即制,Canapés,公司開幕,雞尾酒會,大型活動"
      }
    },
    {
      path: "/en/equiry",
      name: "enquiryen",
      component: equiry,
      meta: {
        title:
          "Tailor-made Catering Service - Quote Now - Cateraway",
        description:
          "Specialize in more than 30 different types of business event catering quotes, food and services including chefs, Canapés, Finger Food, company opening, cocktail party, lunch, large events, snack platter, anniversary party, etc., provide 1 to 1 The special person will come to the conference quotation service.",
        keywords:
          "Event catering offer, quotation service, chef ready, Canapés, company opening, cocktail party, large event"
      }
    },
    {
      path: "/contact",
      name: "contact",
      component: contact,
      meta: {
        title: "聯絡我們｜全港餐飲到會- 到會家 Cateraway",
        description:
          "到會家有自設食物工場，能烹調2-2000人不同形式的到會。我們與超過100+的Partyroom長期合作，亦有和不同的活動策劃公司合作多個中環的大型活動包括AIA嘉年華、Clockenflap，歡迎任何公司與我們聯絡合作長期到會服務。",
        keywords: "餐飲到會,聯絡我們,全港到會,中式餐單,西式餐單"
      }
    },
    {
      path: "/en/contact",
      name: "contacten",
      component: contact,
      meta: {
        title:
          "Contact Us - Cateraway",
        description:
          "There is a self-contained food factory in the meeting house, which can cook 2-2000 people in different forms. We have long-term cooperation with more than 100+ Partyrooms, and we have cooperated with different event planning companies. Many large-scale events in Central include AIA Carnival and Clockenflap. Any company is welcome to contact us for long-term service.",
        keywords:
          "Food and beverages, contact us, Hong Kong to the meeting, Chinese menu, Western menu"
      }
    },
    {
      path: "/corporate-catering",
      name: "corporateCatering",
      component: corporateCatering,
      meta: {
        title: "公司到會 | 商務到會 | 商戶合作 - 到會家 Cateraway\n",
        description:
          "多年來服務超過300家企業，公司到會推介：商務到會、Deluxe精緻套餐、商務自助餐。我們可以提供紅酒白酒。另設有爐具及西式餐具租借，為您的活動提供更完整的公司到會服務！",
        keywords:
          "Partyroom合作,活動策劃合作,公司合作,商戶合作,大型活動,長期到會,公司到會"
      }
    },
    {
      path: "/en/corporate-catering",
      name: "corporateCateringen",
      component: corporateCatering,
      meta: {
        title: "Corporate & Office Catering Service Hong Kong - Cateraway",
        description:
          "Cateraway has been offering corporate catering service to over 300 HK companies and corporates. Our chefs possess more than 20 years experience in different types of cuisines.",
        keywords:
          "corporate catering,corporate catering service,corporate catering hk "
      }
    },
    // {
    //   path: "/cart",
    //   name: "cart",
    //   component: cart
    // },
    // {
    //   path: "/en/cart",
    //   name: "carten",
    //   component: cart
    // },
    {
      path: "/call",
      name: "call",
      component: call
    },
    {
      path: "/footer",
      name: "footer",
      component: footer
    },
    {
      path: "/party-food",
      name: "partyFood",
      component: partyFood,
      meta: {
        title: "派對食物到會 | 小朋友 Party 到會 - 到會家 Cateraway",
        description:
          "到會家在不同類型的派對到會方面的經驗是市場上屈指可數的領導者，我們固有的Partyroom場地合作伙伴在香港超過150間, 另外還設有專屬兒童派對食物，令小朋友跟大人都食得開心！",
        keywords: "派對到會,派對食物, party 到會"
      }
    },
    {
      path: "/en/party-food",
      name: "partyFooden",
      component: partyFood,
      meta: {
        title: "Party Food & Canape Delivery Hong Kong - Cateraway",
        description:
          "Cateraway provides personalized Party food and Canape services. Tailor made the food menu for your parties. Our catering experts have thirty years+ catering experience. Delivery to the whole Hong Kong. Order Now.",
        keywords: "Party Food, Party Catering"
      }
    },
    {
      path: "/christmas-party",
      name: "christmasParty",
      component: christmasParty,
      meta: {
        title: "聖誕到會 | 聖誕派對美食到會 - 到會家 Cateraway",
        description:
          "今年$98/款自選1人1款皇牌聖誕到會陪您過聖誕聯歡會、公司party、是聖誕party首選！原隻燒火雞、聖誕乳酸爆珠雜果沙律、cupcake等聖誕到會，帶來更濃厚的氣氛！",
        keywords: "聖誕到會"
      }
    },
    {
      path: "/en/christmas-party",
      name: "christmasPartyen",
      component: christmasParty,
      meta: {
        title: "Christmas Party Catering - Cateraway",
        description:
          "This year’s $98/one choice 1 person 1 emperor Christmas will accompany you to Christmas, Christmas party, company party, Christmas party preferred! Originally only turkey, Christmas lactic acid popcorn, salad, and other Christmas parties, bring a more intense atmosphere!",
        keywords: "Christmas is coming"
      }
    },
    {
      path: "/birthday-party",
      name: "birthdayParty",
      component: birthdayParty,
      meta: {
        title: "生日到會 | 小朋友生日會 - 到會家 Cateraway",
        description:
          "到會家主營多年小朋友生日會到會，餐單設計加入了多款無激素及營養均衡的食材專為小朋友而設，令到家長及小朋友都可以在生日會吃得開心和健康，一起來見證孩子的歡笑吧。",
        keywords: "生日到會,小朋友生日會"
      }
    },
    {
      path: "/en/birthday-party",
      name: "birthdayPartyen",
      component: birthdayParty,
      meta: {
        title:
          "Birthday Party, Kids and Children Party Catering - Cateraway",
        description:
          "To the family’s main year of children‘s birthday to the meeting, the menu design has added a variety of hormone-free and nutritious ingredients for children, so that parents and children can have a happy and healthy birthday, a Get up and witness the laughter of the child",
        keywords: "Birthday, children’s birthday party"
      }
    },
    {
      path: "/junk-catering",
      name: "junkCatering",
      component: junkCatering,
      meta: {
        title: "船 p 到會 | 船河到會 - 到會家 Cateraway",
        description:
          "到會家推薦船P到會每人任選一款！30人30款的超美味及平價到會，船河食物不用再擔心款式少的問題，無論甜品、小食、沙律及主食都全部任你選，男士女士們都合適！",
        keywords: "船P派對到會,船河派對到會,船P食物, 船P"
      }
    },
    {
      path: "/en/junk-catering",
      name: "junkCateringen",
      component: junkCatering,
      meta: {
        title:
          "Junk Boat Party Catering Packages - Cateraway",
        description:
          "Cateraway provides personalized Junk Boat Party food services. Tailor made the food menu for your parties. Our catering experts have thirty years+ catering experience. Delivery to the whole Hong Kong. Order Now.",
        keywords: "Junk Boat Party Food, Junk Boat Party Catering"
      }
    },
    {
      path: "/wedding-catering",
      name: "weddingCatering",
      component: weddingCatering,
      meta: {
        title: "婚禮到會推介 - 到會家 Cateraway",
        description:
          "我們推介會為您進行一對一的婚禮到會訂制，可以根據您的婚禮推介更美好的食物，量身定做到會套餐，從小食、甜品、飲品等，我們都一絲不苟為你見證人生最難忘的一刻和分享喜悅！",
        keywords: "婚禮到會,婚禮到會推介"
      }
    },
    {
      path: "/en/wedding-catering",
      name: "weddingCateringen",
      component: weddingCatering,
      meta: {
        title: "Wedding Catering Service - Wedding Party - Cateraway",
        description:
          "Cateraway provides personalized wedding catering services. Tailor made the food and drink menu for your dream wedding banquet. Wide range of cuisine including Thai, Western, Chinese, Vegetarian food that fit the theme of your wedding party. Delivery to the whole Hong Kong. Order Now.",
        keywords: "Wedding is coming, wedding will be recommended"
      }
    },
    {
      path: "/snack-catering",
      name: "snackCatering",
      component: snackCatering,
      meta: {
        title: "到會小食 - 到會家 Cateraway",
        description: "到會家新推出到會小食，超過50款食物給您任選！有炸物及拼盤、沙律、冷盤、烘焙包點及甜品等等的小食。小食特色包括泰式、中式、西式和日式等等，個個都話食過小食都返尋味啊！",
        keywords: "到會小食"
      }
    },
    {
      path: "/en/snack-catering",
      name: "snackCateringen",
      component: snackCatering,
      meta: {
        title: "To the snacks - to the club Cateraway",
        description:
          "To the new home to the club will be a snack, more than 50 foods for you to choose! Snacks with burgers and platters, salads, cold cuts, baked goods and desserts. The snacks feature Thai, Chinese, Western and Japanese, etc., all of which have been eaten for snacks!",
        keywords: "to the snacks"
      }
    },
    {
      path: "/chinese-catering",
      name: "chineseCatering",
      component: chineseCatering,
      meta: {
        title: "中式到會 | 中菜到會 - 到會家 Cateraway",
        description:
          "到會家有30年中餐經驗大廚主理廣東菜、素菜及傳統自家菜等中式到會，每逢佳節大厨都會親自編中式餐牌，如果親朋好友太多，就快訂購我們中菜送到府上作「加餸」慶佳節！",
        keywords: "中式到會 中式到會推介 新年到會"
      }
    },
    {
      path: "/en/chinese-catering",
      name: "chineseCateringen",
      component: chineseCatering,
      meta: {
        title: "Chinese Catering - Cateraway",
        description:
          'Cateraway provides personalized chinese catering services. Tailor made the food and hot pot menu for your chinese new year catering. Our catering experts have thirty years+ catering experience. Delivery to the whole Hong Kong. Order Now.',
        keywords: "Chinese Catering"
      }
    },
    {
      path: "/western-catering",
      name: "westernCatering",
      component: westernCatering,
      meta: {
        title: "西式到會 - 到會家 Cateraway",
        description:
          "西式到會餐單由超過20年西餐經驗的大廚設計，我們還有精美西式小食、杯裝小食、高級商務小食、finger food及canapés到會等。讓我們設計您公司活動的西式到會餐單。",
        keywords: "西式到會"
      }
    },
    {
      path: "/en/western-catering",
      name: "westernCateringen",
      component: westernCatering,
      meta: {
        title: "Western Cuisine Catering - Cateraway",
        description:
          "Western style dinner menu is designed by chefs with more than 20 years of western experience. We also have fine Western snacks, cup snacks, advanced business snacks, finger food and canapés. Let us design a Western-style meal menu for your company‘s activities.",
        keywords: "Western style to the meeting"
      }
    },
    {
      path: "/thai-catering",
      name: "thaiCatering",
      component: thaiCatering,
      meta: {
        title: "泰式到會 | 泰菜到會 - 到會家 Cateraway",
        description:
          "到會家的泰式到會餐單亦是由公司旗下的泰國餐廳廚師共同開發，所有的泰式到會是完全加入了當地風味！泰式食物推介有炒金邊粉、豬頸肉、傳統菠蘿炒飯及椰汁千層糕等等。",
        keywords: "泰式到會",
      }
    },
    {
      path: "/en/thai-catering",
      name: "thaiCateringen",
      component: thaiCatering,
      meta: {
        title: "Thai Catering - Cateraway",
        description:
          "The Thai-style menu to the club is also jointly developed by the company’s Thai restaurant chefs. All the Thai styles are completely Thai! Thai food is recommended for Thai fried Phnom Penh powder, Thai pork neck meat, traditional pineapple fried rice and coconut milk layer cake.",
        keywords: "Thai style to the meeting"
      }
    },
    {
      path: "/vegetarian-catering",
      name: "vegetarianCatering",
      component: vegetarianCatering,
      meta: {
        title: "素食到會推介 - 到會家 Cateraway",
        description:
          "到會家除了皇牌餐單中的無肉之選之外，我們還可以烹調出中式及西式素食到會。我們誠邀多年西餐素食經驗大廚花費2年時間嚴選材料編制出自家素食到會，健康由食開始！",
        keywords: "素食到會"
      }
    },
    {
      path: "/en/vegetarian-catering",
      name: "vegetarianCateringen",
      component: vegetarianCatering,
      meta: {
        title: "Vegetarian, Vegan Catering - Cateraway",
        description:
          "In addition to the meat-free selection in the Royal Restaurant menu, we can also cook Chinese vegetarian and Western vegetarian food. We sincerely invite many years of Western vegetarian experience chefs to spend 2 years to select materials to prepare their own vegetarian food, health begins with food!",
        keywords: "Vegetarian to the meeting"
      }
    },
    {
      path: "/bento",
      name: "bento",
      component: bento,
      meta: {
        title: "便當 | 公司飯盒 | 便當盒 - 到會家 Cateraway",
        description:
          "到會家會為您的公司每一位同事和上司設計一份完美的午餐便當，這將會是從前菜到甜點的一份體驗。如果您想為您的公司訂製便當，歡迎聯絡我們！這會是一個承載愛和心意的美食！",
        keywords: "便當"
      }
    },
    {
      path: "/en/bento",
      name: "bentoen",
      component: bento,
      meta: {
        title: "Bento Lunch Box, Packed Meals Delivery - Cateraway",
        description:
          "To the club will design a perfect lunch box for each colleague and supervisor of your company. This will be an experience from the former to the dessert. If you would like to order a lunch for your company, please contact us! This will be a food that carries love and heart!",
        keywords: "便当",
      }
    },
    {
      path: "/central-and-western",
      name: "centralAndWestern",
      component: centralAndWestern,
      meta: {
        title: "中環到會 - 到會家 Cateraway",
        description:
          "到會家專營超過100家中環公司到會，在中環到會曾服務包括Clockenflap音樂文化節、AIA嘉年華、中環太陽戲團、18+Central、公司雞尾酒會、公司商務會議等等。",
        keywords: "中環到會"
      }
    },
    {
      path: "/en/central-and-western",
      name: "centralAndWesternen",
      component: centralAndWestern,
      meta: {
        title: "Central, Kennedy Town and Sai Ying Pun Catering - Cateraway",
        description:
          "To the club‘s franchise, more than 100 Central companies have attended the conference, including the Clockenflap Music and Culture Festival, AIA Carnival, Central Sun Theatre, 18+Central, Corporate Cocktail Club, Corporate Business Conference, etc.",
        keywords: "Central to the meeting"
      }
    },
    {
      path: "/eastern",
      name: "eastern",
      component: eastern,
      meta: {
        title: "北角到會 - 到會家 Cateraway",
        description:
          "到會家致力於鑽研北角到會新菜式服務各個商會及學校，商會服務如雞尾酒會、大型商業會議、船P、宴會、例會等都是我們服務的範疇內，另外學校的節日聯歡會、校運會、開放日等服務我們亦能為你服務。",
        keywords: "北角到會"
      }
    },
    {
      path: "/en/eastern",
      name: "easternen",
      component: eastern,
      meta: {
        title: "North Point Catering - Cateraway",
        description:
          "To the club is committed to delving into the North Point to the new cuisines of various chambers of commerce and schools, chamber services such as cocktail parties, large-scale business meetings, boat P, banquets, regular meetings, etc. are within the scope of our services, and other school festivals We can also serve you for parties such as parties, school games, and open days. ",
        keywords: "North Point to the meeting"
      }
    },
    {
      path: "/wan-chai",
      name: "wanChai",
      component: wanChai,
      meta: {
        title: "銅鑼灣到會 - 到會家 Cateraway",
        description:
          "到會家針對銅鑼灣到會從前菜、主食、小食及甜品的編排、食材的挑選、加工的程序都有大廚親自監管！公司講座、分享會、宴會、典禮、遊艇會等活動中提供到會餐飲服務。",
        keywords: "銅鑼灣到會"
      }
    },
    {
      path: "/en/wan-chai",
      name: "wanChaien",
      component: wanChai,
      meta: {
        title: "Wan Chai Catering - Cateraway",
        description:
          "To the meeting, the chefs will personally supervise the procedures for the arrangement, processing and processing of the ingredients, ingredients, snacks and desserts in Causeway Bay! Catering services are provided in company lectures, sharing sessions, banquets, ceremonies, yacht clubs and other activities.",
        keywords: "Causeway Bay to the meeting"
      }
    },
    {
      path: "/kwun-tong",
      name: "kwunTong",
      component: kwunTong,
      meta: {
        title: "觀塘到會 | 牛頭角/九龍灣到會 - 到會家 Cateraway",
        description:
          "到會家針對不同商業活動製作$82/款的皇牌餐單，觀塘到會、牛頭角到會及九龍灣到會更是我們主要的客戶來源，推介公司例會、典禮、派對、講座和開張活動等公司活動訂購。",
        keywords: "觀塘到會,牛頭角到會,九龍灣到會"
      }
    },
    {
      path: "/en/kwun-tong",
      name: "kwunTongen",
      component: kwunTong,
      meta: {
        title:
          "Kwun Tong, Ngau Tau Kok, Kowloon Bay Catering Service - Cateraway",
        description:
          "Cateraway provides catering services to Kwun Tong, Ngau Tau Kok, and Kowloon Bay. Customize your corporate catering services, business events at Kwun Tong area including business lunches, cocktail parties, or breakfasts for morning meetings. Order Now.",
        keywords: "kwun tong catering "
      }
    },
    {
      path: "/sham-shui-po",
      name: "shamShuiPo",
      component: shamShuiPo,
      meta: {
        title: "長沙灣到會 - 到會家 Cateraway",
        description:
          "到會家專門為商業、住宅、工業等用地提供$82／款物美價廉的長沙灣及荔枝角到會服務，餐單包括多國的特色菜式如泰國菠蘿炒飯、道地卡邦尼長通粉等更是長沙灣到會的熱門首選。",
        keywords: "長沙灣到會"
      }
    },
    {
      path: "/en/sham-shui-po",
      name: "shamShuiPoen",
      component: shamShuiPo,
      meta: {
        title: "Sham Shui Po Catering - Cateraway",
        description:
          "To the club is dedicated to commercial, residential, industrial and other places to provide $82 / inexpensive Changsha Bay and Lai Chi Kok service, the menu includes multi-national specialties such as Thai pineapple fried rice, Doka Kabang Nichangtong powder is a popular choice for Changsha Bay",
        keywords: "Changsha Bay to the meeting"
      }
    },
    {
      path: "/yau-tsim-mong",
      name: "yauTsimMong",
      component: yauTsimMong,
      meta: {
        title: "尖沙咀到會 | 旺角到會 - 到會家 Cateraway",
        description:
          "到會家搜羅了不同國家、地區的菜式，從中挑選出適合尖沙咀到會及旺角到會的市場製作出獨特的菜式，$82就可體驗上至頭盤、主菜、小食及甜品下至運輸一條龍服務。",
        keywords: "尖沙咀到會,旺角到會"
      }
    },
    {
      path: "/en/yau-tsim-mong",
      name: "yauTsimMongen",
      component: yauTsimMong,
      meta: {
        title:
          "Yau Tsim Mong Catering - Cateraway",
        description:
          "To the family, we have collected dishes from different countries and regions, and selected a market suitable for Tsim Sha Tsui to attend the meeting and Mong Kok to produce unique dishes. For $82, you can experience the first dish, main course and snacks. Dessert down to transport one-stop service.",
        keywords: "Tsim Sha Tsui to the meeting, Mong Kok to the meeting"
      }
    },
    {
      path: "/kwai-tsing",
      name: "kwaiTsing",
      component: kwaiTsing,
      meta: {
        title: "葵涌到會 - 到會家 Cateraway",
        description:
          "超過50款食物給選擇葵涌到會的您揀！由30年大廚主理中式、西式、泰式的到會。如果想訂購葵涌到會美食，除了電話預訂以外，亦可在到會家的網站預訂美食，提提您記得提前三天預訂！",
        keywords: "葵涌到會"
      }
    },
    {
      path: "/en/kwai-tsing",
      name: "kwaiTsingen",
      component: kwaiTsing,
      meta: {
        title: "Kwai Chung Catering - Cateraway",
        description:
          "More than 50 foods are available for you to choose from Kwai Chung! The chef of the 30-year-old chef is in charge of Chinese, Western and Thai styles. If you want to order Kwai Chung to the food, in addition to the telephone reservation, you can also book food on the website of the club, mentioning that you remember to book three days in advance! ",
        keywords: "Kwai Chung to the meeting"
      }
    },
    {
      path: "/sai-kung",
      name: "saiKung",
      component: saiKung,
      meta: {
        title: "西貢到會 | 將軍澳到會 - 到會家 Cateraway",
        description:
          "專門提供西貢到會、將軍澳到會、康城及寶琳到會，滿足您船P、沙灘野餐、家庭聚會、船河等到會選擇。只需$82您就可以按照自己喜好挑選超過50款不同的食物組合，包您滿意！",
        keywords: "西貢到會,將軍澳到會"
      }
    },
    {
      path: "/en/sai-kung",
      name: "saiKungen",
      component: saiKung,
      meta: {
        title:
          "Sai Kung Catering - Cateraway",
        description:
          "Specially provide Saigon to the meeting, Tseung Kwan O to the meeting, Kangcheng and Baolin to meet, meet your boat P, beach picnic, family gatherings, boat rivers and so on. For just $82, you can choose from over 50 different food combinations to suit your preferences.",
        keywords: "Saigong to the meeting, Tseung Kwan O to the meeting"
      }
    },
    {
      path: "/sha-tin",
      name: "shaTin",
      component: shaTin,
      meta: {
        title: "沙田到會 - 到會家 Cateraway",
        description:
          "到會家是家庭客人沙田到會首選的原因是我們美食種類居多，從前菜到甜品有超過50款的美食。每一道菜式由20年西式餐廳大廚主理，為您家庭中的每一位成員考慮，立即打電話或網上預訂到會！",
        keywords: "沙田到會"
      }
    },
    {
      path: "/en/sha-tin",
      name: "shaTinen",
      component: shaTin,
      meta: {
        title: "Sha Tin Catering - Cateraway",
        description:
          "The reason why the family is the first choice for family guests in Shatian is that we have a wide variety of foods, from top dishes to desserts with more than 50 dishes. Each dish is hosted by a 20-year Western restaurant chef and is considered for every member of your family. Call now or book online! ",
        keywords: "Shatian to the meeting"
      }
    },
    {
      path: "/tsuen-wan",
      name: "tsuenWan",
      component: tsuenWan,
      meta: {
        title: "荃灣到會 - 到會家 Cateraway",
        description:
          "荃灣到會首選皇牌餐單，$82自選餐單從甜品、主食、小食都適合不同年齡層享用。每隔6個月就會推出一份新的潮流餐牌，顧客每一次來都有不同的體驗，將千奇百款的美食呈現在您眼前。",
        keywords: "荃灣到會"
      }
    },
    {
      path: "/en/tsuen-wan",
      name: "tsuenWanen",
      component: tsuenWan,
      meta: {
        title: "Tsuen Wan Catering - Cateraway",
        description:
          "The best choice for the restaurant in Tsuen Wan, the $82 optional menu from desserts, staple foods, snacks are suitable for different age groups. Every six months, a new trend menu will be launched, and customers will have different experiences every time, and present a variety of foods in front of you.",
        keywords: "荃灣到會"
      }
    },
    {
      path: "/tuen-mun",
      name: "tuenMun",
      component: tuenMun,
      meta: {
        title: "屯門到會 - 到會家 Cateraway",
        description:
          "網羅100款獨特的美食給屯門到會的朋友，全球配送食物。包括不同有名的各國餐館菜式、潮流特色美食、打卡甜品都應有盡有，還有專屬車隊為你送上熱辣辣的美食，快啲嚟揀啦！",
        keywords: "屯門到會"
      }
    },
    {
      path: "/en/tuen-mun",
      name: "tuenMunen",
      component: tuenMun,
      meta: {
        title: "Tuen Mun Catering - Cateraway",
        description:
          "The 100 unique foods for the friends who come to Tuen Mun, the global distribution of food. Including different famous restaurants, trendy specialties, and punched desserts, there are also exclusive teams to send you hot food, pick it up!",
        keywords: "屯門到會"
      }
    },
    {
      path: "/yuen-long",
      name: "yuenLong",
      component: yuenLong,
      meta: {
        title: "元朗到會 - 到會家 Cateraway",
        description:
          "到會家元朗到會專屬車隊為你服務，元朗的朋友們不用再擔心地區的問題喇！到會家收集中西泰日特色菜式，足不出戶就可以試足不同國家的特色小食、主食、甜品、素食等！",
        keywords: "元朗到會"
      }
    },
    {
      path: "/en/yuen-long",
      name: "yuenLongen",
      component: yuenLong,
      meta: {
        title: "Yuen Long Catering - Cateraway",
        description:
          "To the club Yuen Long to the exclusive team to serve you, friends in Yuen Long no longer have to worry about the regional problems! At the meeting, you can collect Chinese, Western, Thai and Japanese specialties, and you can try out different specialty snacks, staple foods, desserts, vegetarian foods, etc. in different countries!",
        keywords: "Yuanlang to the meeting"
      }
    },
    {
      path: "/proDetails",
      name: "proDetails",
      component: proDetails
    },
    {
      path: "en/proDetails",
      name: "proDetailsen",
      component: proDetails
    },
    {
      path: "/order",
      name: "order",
      component: index,
    },
    {
      path: "/en/order",
      name: "enorder",
      component: index,
    },
    {
      path: "/find",
      name: "find",
      component: index,
    },
    {
      path: "/en/find",
      name: "enfind",
      component: index,
    },
    {
      path: "/about-us",
      name: "aboutus",
      component: index,
    },
    {
      path: "/en/about-us",
      name: "enaboutus",
      component: index,
    },
    {
      path: "/404",
      name: "caterers",
      component: notfind,
    },
    {
      path: '*',
      redirect: '/404'
    },
    {
      path: "/gift",
      name: "gift",
      component: ()=>import('@/views/GiftArea/index.vue'),
      meta: {
        title: "送禮專區 | 生日禮物 | 聖誕禮物 | 情侶送禮 - 到會家 Cateraway",
        description:"平時送禮係咪好頭痕？擔心對方不喜歡該禮物，又怕送錯禮物，到會家能幫到你！我們提供最適合送禮的產品，生日禮物，聖誕禮物，男士送禮，女士送禮應有盡有！無論男女老少都推薦使用！",
        keywords: "送禮, 禮物,  禮物推薦，生日禮物，聖誕禮物，男士送禮，女士送禮"
      }
    },
    {
      path: "/en/gift",
      name: "Engift",
      component: ()=>import('@/views/GiftArea/index.vue'),
      meta: {
        title: "Gift - Cateraway",
        description: "Giving gifts to each other is a good way for both parties to maintain a good relationship, but giving gifts has also become the biggest problem for Hong Kong people. They are worried that the other party will not like the gift, and they are afraid of sending the wrong gift. We have the best products for gifts, birthday gifts, Christmas gifts, gifts for men, gifts for women, everything! Recommended for men and women of all ages!",
        keywords: "送禮, 禮物,  禮物推薦，生日禮物，聖誕禮物，男士送禮，女士送禮"
      }
    },
  ],
  scrollBehavior(to, from, savedPosition) {
    if (to.path === "/caterers/1" && from.fullPath === "/") {
      return { x: 0, y: 600 };
    }
    if (to.path === "/caterers/2" && from.fullPath === "/") {
      return { x: 0, y: 1900 };
    }
    if (to.path === "/caterers/3" && from.fullPath === "/") {
      return { x: 0, y: 2770 };
    }
    if (to.path === "/caterers/4" && from.fullPath === "/") {
      return { x: 0, y: 3270 };
    }
    if (to.path === "/caterers/5" && from.fullPath === "/") {
      return { x: 0, y: 3770 };
    }
    if (to.path === "/caterers/6" && from.fullPath === "/") {
      return { x: 0, y: 4640 };
    }
    return { x: 0, y: 0 };
  }
});
